﻿import { AccountInfo, Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENTID ?? "EMPTY",
        authority: process.env.REACT_APP_B2C_AUTHORITY,
        knownAuthorities: [process.env.REACT_APP_B2C_KNOWAUTHORITIES ?? "EMPTY"],
        redirectUri: process.env.REACT_APP_WEBAPP_URL,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
}

export const apiScopes: string[] = [process.env.REACT_APP_B2C_APISCOPES ?? "EMPTY"];

/**
 * Authority of the B2C custom policy used for SAML single sign-on (B2C_1A_PATHTA_SSO).
 * Optional: when it is not set, SSO is never offered and every user signs in through the regular authority.
 */
export const ssoAuthority: string | undefined = process.env.REACT_APP_B2C_SSO_AUTHORITY || undefined;

const ssoPolicyName: string | undefined = ssoAuthority?.split('/').filter(Boolean).pop()?.toLowerCase();

/** True if the account signed in through the SSO custom policy (B2C puts the policy in the tfp claim, acr for older tokens). */
export function isSsoAccount(account?: AccountInfo | null): boolean {
    if (!ssoPolicyName || !account?.idTokenClaims) {
        return false;
    }

    const claims = account.idTokenClaims as Record<string, unknown>;

    return String(claims.tfp ?? claims.acr ?? '').toLowerCase() === ssoPolicyName;
}

/**
 * Token requests of an SSO account must target the SSO policy: a refresh token issued by one policy cannot be redeemed
 * at another. The domain hint (claim idp) is replayed so that an interactive renewal goes back to the same
 * identity provider without showing the provider selection page. Empty for regular accounts.
 */
export function getSsoRequestParameters(account?: AccountInfo | null): { authority?: string; extraQueryParameters?: Record<string, string> } {
    if (!isSsoAccount(account)) {
        return {};
    }

    // B2C emits the claim type identityProvider under its OpenID Connect name: idp.
    const claims = account!.idTokenClaims as Record<string, unknown>;
    const domainHint = claims.idp ?? claims.identityProvider;

    return {
        authority: ssoAuthority,
        extraQueryParameters: domainHint ? { domain_hint: String(domainHint) } : undefined
    };
}
